import FeedbackPage from "./feedback";
export default FeedbackPage;
